export default "__VITE_ASSET__D8IV4xU9__"